__turbopack_context__.v({
  "checkIcon": "BrowsingLevelsGrouped-module-scss-module__0ezdoa__checkIcon",
  "iconWrapper": "BrowsingLevelsGrouped-module-scss-module__0ezdoa__iconWrapper",
  "label": "BrowsingLevelsGrouped-module-scss-module__0ezdoa__label",
  "root": "BrowsingLevelsGrouped-module-scss-module__0ezdoa__root",
});
